import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LibPipeModule } from '@mynexus/mynexus-ui-lib';
import { LibDirectiveModule } from '@mynexus/mynexus-ui-lib';
import { PrimeNgModule } from '@shared/primeng/prime-ng.module';

import { SendFaxComponent } from './send-fax.component';
// Shared
import { DocumentsListModule } from '@app/documents/documents-list/documents-list.module';
import { AttachmentsSharedComponent } from '../../products/pac/components/shared/attachments-shared/attachments-shared.component';
import { FaxProviderDetailsComponent } from '../../products/pac/components/shared/fax-provider-details/fax-provider-details.component';
import { AdditionalFaxProviderDetailsComponent } from '../../products/pac/components/shared/additional-fax-provider-details/additional-fax-provider-details.component';
import { SharedErrorsMessagesComponent } from "../../shared/components/shared-errors-messages/shared-errors-messages.component";
import { SingleServicelineSharedComponent } from '@app/products/pac/components/shared/app-single-serviceline-shared/single-serviceline-shared.component';
import { ServicesSharedComponent } from '@app/products/pac/components/shared/app-services-shared/services-shared.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FluidModule } from 'primeng/fluid';

@NgModule({
  declarations: [
    SendFaxComponent,
    AttachmentsSharedComponent,
    FaxProviderDetailsComponent,
    AdditionalFaxProviderDetailsComponent,
    SingleServicelineSharedComponent,
    ServicesSharedComponent
  ],
  exports: [
    SendFaxComponent,
    AttachmentsSharedComponent,
    FaxProviderDetailsComponent,
    AdditionalFaxProviderDetailsComponent,
    SingleServicelineSharedComponent,
    ServicesSharedComponent
  ],
  imports: [
    CommonModule,
    DocumentsListModule,
    ReactiveFormsModule,
    FormsModule,
    LibPipeModule,
    PrimeNgModule,
    LibDirectiveModule,
    SharedErrorsMessagesComponent,
    SelectButtonModule,
    FluidModule
  ]
})

export class SendFaxModule { }
